import { Link } from 'react-router-dom';

interface AuthLegalLinksProps {
  backLabel?: string;
  backTo?: string;
  includesContestRules?: boolean;
}

const legalLinks = [
  { label: 'Terms', href: '/terms' },
  { label: 'Privacy', href: '/privacy' },
  { label: 'Official Rules', href: '/official-rules' },
  { label: 'Privacy Choices', href: '/privacy-choices' },
  { label: 'Accessibility', href: '/accessibility' },
  { label: 'Help', href: '/help' },
  { label: 'Contact', href: '/contact' },
];

function AuthLegalLinks({
  backLabel = 'Back to home',
  backTo = '/',
  includesContestRules = false,
}: AuthLegalLinksProps) {
  return (
    <nav className="mt-8 pb-40 text-center" aria-label="Account legal and support links">
      <p className="mx-auto max-w-sm text-xs leading-5 text-slate-400">
        By continuing, you agree to the{' '}
        <Link to="/terms" className="font-semibold text-emerald-300 hover:text-emerald-200">
          Terms
        </Link>{' '}
        and acknowledge the{' '}
        <Link to="/privacy" className="font-semibold text-emerald-300 hover:text-emerald-200">
          Privacy Policy
        </Link>
        {includesContestRules ? (
          <>
            {' '}
            and the{' '}
            <Link
              to="/official-rules"
              className="font-semibold text-emerald-300 hover:text-emerald-200"
            >
              Official Rules
            </Link>
          </>
        ) : null}
        .
      </p>

      {includesContestRules && (
        <p className="mx-auto mt-2 max-w-sm text-[11px] leading-5 text-slate-400">
          Free entry. No purchase necessary. Void where prohibited. BracketBlitz is an independent
          fan game.
        </p>
      )}

      <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs">
        {legalLinks.map(link => (
          <Link
            key={link.href}
            to={link.href}
            className="font-medium text-slate-300 transition-colors hover:text-emerald-300"
          >
            {link.label}
          </Link>
        ))}
      </div>

      <Link
        to={backTo}
        className="mt-5 inline-flex min-h-11 items-center text-sm font-medium text-slate-300 transition-colors hover:text-white"
      >
        &larr; {backLabel}
      </Link>
    </nav>
  );
}

export default AuthLegalLinks;
